import React from "react";
import styles from "./NationalityList.module.css";
import { getLanguageDisplayName } from "../../../utils/language";
import { HubAnalyticsLanguageRow } from "../types";
import { formatPercent } from "../utils/formatNumber";

interface NationalityListProps {
    title: string;
    data?: HubAnalyticsLanguageRow[];
    emptyLabel: string;
    /** Maximum rows to render. Defaults to 8 (six on the design + a small buffer). */
    maxRows?: number;
}

const NationalityList: React.FC<NationalityListProps> = ({ title, data = [], emptyLabel, maxRows = 8 }) => {
    const sorted = [...data].sort((a, b) => b.percentage - a.percentage).slice(0, maxRows);

    return (
        <section className={styles.card}>
            <h3 className={styles.title}>{title}</h3>
            {sorted.length === 0 ? (
                <p className={styles.empty}>{emptyLabel}</p>
            ) : (
                <div className={styles.grid}>
                    {sorted.map((row) => {
                        const pct = Math.max(0, Math.min(100, row.percentage));
                        return (
                            <div key={row.language} className={styles.row}>
                                <span className={styles.name}>{getLanguageDisplayName(row.language)}</span>
                                <span className={styles.percent}>{formatPercent(row.percentage, 1)}</span>
                                <span className={styles.bar}>
                                    <span className={styles.barFill} style={{ width: `${pct}%` }} />
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </section>
    );
};

export default NationalityList;
